import script from "./RemoveBackground.vue?vue&type=script&setup=true&lang=ts"
export * from "./RemoveBackground.vue?vue&type=script&setup=true&lang=ts"

import "./RemoveBackground.scss?vue&type=style&index=0&id=d2bd7de8&scoped=true&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d2bd7de8"]])

export default __exports__